import MatchPlayItem from './match-play-item'

export default MatchPlayItem
